import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/queries/admin/adminQueryKeys.ts
var t = e("admin-auth", { me: () => ["me"] });
//#endregion
export { t as adminQueryKeys };
